"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPERIMENT_GATE_CHECK_INTERVAL_MS = exports.CLIENT_REFRESH_SERVER_POLLING_INTERVAL_MS = exports.CLIENT_REFRESH_CHECK_INTERVAL_MS = void 0;
exports.CLIENT_REFRESH_CHECK_INTERVAL_MS = 20 * 1000;
exports.CLIENT_REFRESH_SERVER_POLLING_INTERVAL_MS = 2 * 60 * 1000;
exports.EXPERIMENT_GATE_CHECK_INTERVAL_MS = 30 * 1000;
//# sourceMappingURL=clientStatusUtils.js.map